import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getDatesExistsOokla } from '@api/ookla';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { refetchOptions } from '@constants/common';
import { DATES_OOKLA } from '@constants/queryKeys';

interface IUseQueryDatesOoklaReturn {
	isLoadingDatesOokla: boolean;
	datesOokla: Array<Date>;
}

export const useQueryDatesOokla = (): IUseQueryDatesOoklaReturn => {
	const {
		accessPermission: {
			assetConsumerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			assetOwnerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const isAllowed = (
		assetConsumerOrganizationAdministrator ||
		networkOperatorOrganizationAdministrator ||
		assetOwnerOrganizationAdministrator
	);

	const {
		data: datesOokla,
		isLoading: isLoadingDatesOokla,
		isFetching: isFetchingDatesOokla,
	} = useQuery<Array<string>, Array<Date>>({
			queryKey: [DATES_OOKLA],
			queryFn: extractQueryParams(getDatesExistsOokla),
			select: (dates) => dates.map((date) => parseStringDate(date)),
			enabled: [isAllowed],
			...refetchOptions,
		},
	);

	return {
		isLoadingDatesOokla: isLoadingDatesOokla || isFetchingDatesOokla,
		datesOokla: datesOokla || [],
	};
};
